export const mixin = {
  data: () => ({
    fieldProps: {
      outlined: true,
      dense: true,
      color: "primary",
      class: "rounded-0",
      flat: true,
    },
  }),
};
